module.exports = __webpack_public_path__ + "img/Notification.f0f479b7.svg";